import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {SecurityInputModule} from '../../components/security-input';
import {SymbolDecimalsModule} from '../../components/symbol-decimals';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {UserDataStreamingModule} from '../../services/user-data-streaming/user-data-streaming.module';
import {ChartSecurityInputModule} from './chart-security-input';
import {ChartWidgetComponent} from './chart-widget.component';
import {CHART_WIDGET_DESCRIPTION} from './chart-widget.description';
import {ChartDatafeedModule} from './datafeed';
import {CandleStreamingModule} from './datafeed/candle-streaming';
import {ChartWidgetSettingsComponent} from './settings/chart-widget-settings.component';
import {ChartWidgetSettingsService} from './settings/chart-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SecurityInputModule,
        L10nModule,
        AutofocusModule,
        UserDataStreamingModule,
        ChartDatafeedModule,
        CandleStreamingModule,
        ChartSecurityInputModule,
        SymbolDecimalsModule,
        // OrderPlacingModule, // [HED-930] Not used in DEX
        PartialLoadingIndicatorModule
    ],
    declarations: [
        ChartWidgetComponent,
        ChartWidgetSettingsComponent
    ],
    exports: [
        ChartWidgetComponent
    ],
    providers: [
        ChartWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: CHART_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class ChartWidgetModule {}
